import Log from '@/views/Log/Log.vue';
import LogComp from '@/components/Log/LogComp.vue';

export const logRoutes = {
  path: 'log',
  name: 'log',
  component: Log,
  redirect: {
    name: 'logPage',
  },
  children: [
    {
      // This opens up the child components
      name: 'logPage',
      path: '',
      component: LogComp,
    },
  ],
};
